import { apiAction } from "../models/requests";

const appendTokenName = (data) => {
    return data;
};

export function getUrlFilterPolicies(){
    if (window.disableAPIActiveState == undefined || window.disableAPIActiveState == 0) { localStorage.setItem("unActiveStateSec", new Date().getTime()); }
    let data = {};
    appendTokenName(data);
    return apiAction({
        types: ["GET_FILTER_REQUESTED", "GET_FILTER_SUCCESS", "GET_FILTER_FAILED"],
        method: "POST",
        path: "admin/get_url_filter_policies",
        body: data
    });
}

export function getUrlFilterCategories(){
    if (window.disableAPIActiveState == undefined || window.disableAPIActiveState == 0) { localStorage.setItem("unActiveStateSec", new Date().getTime()); }
    let data = {};
    appendTokenName(data);
    return apiAction({
        types: ["GET_FILTER_CATEGORIES_REQUESTED", "GET_FILTER_CATEGORIES_SUCCESS", "GET_FILTER_CATEGORIES_FAILED"],
        method: "POST",
        path: "admin/get_all_categories",
        body: data
    });
}

export function getSafeSearchPatterns(){
    if (window.disableAPIActiveState == undefined || window.disableAPIActiveState == 0) { localStorage.setItem("unActiveStateSec", new Date().getTime()); }
    let data = {};
    appendTokenName(data);
    return apiAction({
        types: ["GET_SAFE_SEARCH_PATTERNS_REQUESTED", "GET_SAFE_SEARCH_PATTERNS_SUCCESS", "GET_SAFE_SEARCH_PATTERNS_FAILED"],
        method: "POST",
        path: "admin/get_safe_search_patterns",
        body: data
    });
}

export function setWebFilterPageInfo({pageSize,pageNo}){
    return {
        type : 'SET_WEB_FILTER_PAGEINFO',
        payload : {pageSize,pageNo }
    }
}

export function deleteUrlFilterPolicy(filter_policy_id){
    if (window.disableAPIActiveState == undefined || window.disableAPIActiveState == 0) { localStorage.setItem("unActiveStateSec", new Date().getTime()); }
    let data = {filter_policy_id: filter_policy_id};
    appendTokenName(data);
    return apiAction({
        types: ["DELETE_FILTER_REQUESTED", "DELETE_FILTER_SUCCESS", "DELETE_FILTER_FAILED"],
        method: "POST",
        path: "admin/delete_url_filter_policy",
        body: data
    });
}

export function createUrlFilterPolicy(filter_policy){
    if (window.disableAPIActiveState == undefined || window.disableAPIActiveState == 0) { localStorage.setItem("unActiveStateSec", new Date().getTime()); }
    let data = {};
    data.target_url_filter_policy = filter_policy;
    appendTokenName(data);
    return apiAction({
        types: ["CREATE_FILTER_REQUESTED", "CREATE_FILTER_SUCCESS", "CREATE_FILTER_FAILED"],
        method: "POST",
        path: "admin/create_url_filter_policy",
        body: data
    });
}

export function updateUrlFilterPolicy(filter_policy){
    if (window.disableAPIActiveState == undefined || window.disableAPIActiveState == 0) { localStorage.setItem("unActiveStateSec", new Date().getTime()); }
    let data = {};
    data.target_url_filter_policy = filter_policy;
    appendTokenName(data);
    return apiAction({
        types: ["UPDATE_FILTER_REQUESTED", "UPDATE_FILTER_SUCCESS", "UPDATE_FILTER_FAILED"],
        method: "POST",
        path: "admin/update_url_filter_policy",
        body: data
    });
}



// WEBPACK FOOTER //
// ./src/actions/actionFilters.js